function getCorrespondingDuration({
  plan,
  mainPeriod = undefined,
  additionalPeriods = undefined
}) {
  if (mainPeriod && plan.durations[mainPeriod]) {
    return plan.durations[mainPeriod]
  } else if (additionalPeriods) {
    return additionalPeriods
      .sort((x, y) => y - x)
      .map(p => plan.durations[p])
      .filter(Boolean)[0]
  }
}

export default getCorrespondingDuration
